import { notification } from "antd";
import { useEffect } from "react";

export const useNotificacionAnt = () => {
	const [api, contextHolder] = notification.useNotification();

	const openNotification = () => {
		api.open({
			message: "",
			description: <div dangerouslySetInnerHTML={{ __html: "" }} />,
			duration: 0,
		});
	};

	useEffect(() => {
		if (false) {
			openNotification();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		contextHolder,
	};
};
